import { render, staticRenderFns } from "./index.vue?vue&type=template&id=70569fdb&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=70569fdb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70569fdb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/BgUizHzZB/0/snt/info/info-customer/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70569fdb')) {
      api.createRecord('70569fdb', component.options)
    } else {
      api.reload('70569fdb', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=70569fdb&scoped=true&", function () {
      api.rerender('70569fdb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/404/index.vue"
export default component.exports